import { useTheme } from '../contexts/ThemeContext';
import {
  BRAND_ICON_LIGHT_SRC,
  BRAND_ICON_SRC,
  BRAND_LOGO_LIGHT_SRC,
  BRAND_LOGO_MARK_LIGHT_SRC,
  BRAND_LOGO_MARK_SRC,
  BRAND_LOGO_SRC,
  BRAND_NAME,
} from '../lib/brand';

type BrandMarkProps = {
  variant?: 'sidebar' | 'full' | 'icon';
  className?: string;
};

export default function BrandMark({ variant = 'sidebar', className = '' }: BrandMarkProps) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  const iconSrc = isDark ? BRAND_ICON_SRC : BRAND_ICON_LIGHT_SRC;
  const logoSrc = isDark ? BRAND_LOGO_SRC : BRAND_LOGO_LIGHT_SRC;
  const markSrc = isDark ? BRAND_LOGO_MARK_SRC : BRAND_LOGO_MARK_LIGHT_SRC;

  if (variant === 'icon') {
    return (
      <span className={`brand-icon-wrap ${className}`.trim()}>
        <img src={iconSrc} alt={BRAND_NAME} className="brand-icon" />
      </span>
    );
  }

  if (variant === 'full') {
    return (
      <div className={`brand-mark-full ${className}`.trim()}>
        <img src={logoSrc} alt={BRAND_NAME} className="brand-logo-full" />
      </div>
    );
  }

  return (
    <div className={`brand-mark ${className}`.trim()}>
      <img src={markSrc} alt={BRAND_NAME} className="brand-logo-sidebar" />
    </div>
  );
}

/** @deprecated Logo artwork includes the gradient accent bar. */
export function BrandGradientBar({ className = '' }: { className?: string }) {
  return null;
}
